export const CSV_UPLOAD_WRONG_FORMAT_ERROR = "File format must be .csv";
